import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import PaymentSellingActions from "../../../../reducers/modules/sales/payment-selling/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "sales/payment-confirmation";

export default class PaymentSellingMiddleware {
  static getPaymentSelling(id, type) {
    return (dispatch) => {
      dispatch(PaymentSellingActions.beforePaymentSelling(type));
      PaymentSellingMiddleware.showPaymentSelling(dispatch, id, type);
    };
  }

  static showPaymentSelling(dispatch, id, type) {
    let params = {
      type: type,
    };
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PaymentSellingMiddleware.getToken()}`,
      },
      url: url + "/list/" + type + "/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PaymentSellingActions.afterPaymentSelling(response.data.result));
        }
      })
      .catch((error) => {
        PaymentSellingMiddleware.alertHendler(dispatch, error);
      });
  }

  static create() {
    return (dispatch) => {
      dispatch(PaymentSellingActions.create());
    };
  }

  static update(params) {
    return (dispatch) => {
      dispatch(PaymentSellingActions.update());
      PaymentSellingMiddleware.showOne(dispatch, params);
    };
  }

  static list(params) {
    return (dispatch) => {
      dispatch(PaymentSellingActions.process());
      PaymentSellingMiddleware.showlist(dispatch, params);
    };
  }
  static reset() {
    return (dispatch) => {
      dispatch(PaymentSellingActions.reset());
    };
  }
  static resetList() {
    return (dispatch) => {
      dispatch(PaymentSellingActions.resetList());
    };
  }
  static getOne(params) {
    return (dispatch) => {
      dispatch(PaymentSellingActions.view());
      PaymentSellingMiddleware.showOne(dispatch, params);
    };
  }

  static beforeSaveNew(post, search) {
    return (dispatch) => {
      dispatch(PaymentSellingActions.submit());
      PaymentSellingMiddleware.saveNew(dispatch, post, search);
    };
  }
  static beforeSaveUpdate(params, post, search) {
    return (dispatch) => {
      dispatch(PaymentSellingActions.submit());
      PaymentSellingMiddleware.saveUpdate(dispatch, params, post, search);
    };
  }
  static beforeDelete(id, params) {
    return (dispatch) => {
      dispatch(PaymentSellingActions.delete());
      PaymentSellingMiddleware.delete(dispatch, params, id);
    };
  }

  static getHelper(params = null) {
    return (dispatch) => {
      PaymentSellingMiddleware.showHelper(dispatch, params);
    };
  }

  static getHelperFull(params = null) {
    return (dispatch) => {
      PaymentSellingMiddleware.showHelperFull(dispatch, params);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }

  static showHelperFull(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PaymentSellingMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-invoice-helper",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PaymentSellingActions.helperFull(response.data.result));
        }
      })
      .catch((error) => {
        PaymentSellingMiddleware.alertHendler(dispatch, error);
      });
  }
  static showlist(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PaymentSellingMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PaymentSellingActions.list(response.data.result));
        }
      })
      .catch((error) => {
        PaymentSellingMiddleware.alertHendler(dispatch, error);
      });
  }
  static showHelper(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PaymentSellingMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-payment",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PaymentSellingActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        PaymentSellingMiddleware.alertHendler(dispatch, error);
      });
  }
  static showOne(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PaymentSellingMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PaymentSellingActions.view(response.data.result));
        }
      })
      .catch((error) => {
        PaymentSellingMiddleware.alertHendler(dispatch, error);
      });
  }

  static delete(dispatch, params, id) {
    axios({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PaymentSellingMiddleware.getToken()}`,
      },
      url: url + "/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PaymentSellingActions.process(),
            PaymentSellingMiddleware.showlist(dispatch, params)
          );
          PaymentSellingMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Delete Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PaymentSellingMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveNew(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PaymentSellingMiddleware.getToken()}`,
      },
      url: url,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PaymentSellingActions.process(),
            PaymentSellingMiddleware.showlist(dispatch, search)
          );
          dispatch(PaymentSellingActions.success());
          PaymentSellingMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Create Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PaymentSellingMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${PaymentSellingMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PaymentSellingActions.process(),
            PaymentSellingMiddleware.showlist(dispatch, search)
          );
          dispatch(PaymentSellingActions.success());
          PaymentSellingMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PaymentSellingMiddleware.alertHendler(dispatch, error);
      });
  }
  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Delete Error",
                html: data.error,
                icon: "error",
                showConfirmButton: true,
              });
            } else {
              const data = result.response.data;
              dispatch(PaymentSellingActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        dispatch(PaymentSellingActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
